define.alias("ember-composable-helpers/helpers/slice", "calendar/helpers/slice");